import React, { useState } from 'react';
import { Modal, Button, Typography, Space, message } from 'antd';
import ApiService from '../Components/apiService';
import { BASE_URL } from '../Components/Constant';
import { useNavigate } from 'react-router-dom';

const { Text } = Typography;

const RefreshOrgModal = ({
  visible,
  onClose,
  sourceOrgId,
  targetOrgId,
  onRefreshSuccess
}) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleCancel = () => {
    onClose();
  };

  const handleConfirm = async () => {
    try {
      setLoading(true);

      const payload = {
        source_org_id: sourceOrgId,
        target_org_id: targetOrgId,
      };

      const apiService = new ApiService(
        `${BASE_URL}/sandbox/refresh`,
        { 'Content-Type': 'application/json' },
        'POST',
        payload
      );

      await apiService.makeCall();

      message.success('Sandbox refresh started successfully!');

      navigate(`/Admin`);

      const payload2 = {

        org_info: {
          target_org_name: 'refresh',          // dynamic org name entered by user
          source_org_id: sourceOrgId,     // maps to source_org_id
          environment_type: 'refresh', // dynamic environment type (free text)
          clone_level: 'Metadata',
          type: 'refresh',
          target_org_id: targetOrgId, 
        },
      };

      const apiService2 = new ApiService(
        `${BASE_URL}/super_admin/org_clone`,
        { 'Content-Type': 'application/json' },
        'POST',
        payload2
      );

      await apiService2.makeCall();
      // message.success(`Organization updated successfully!`);

      handleCancel();
      if (onRefreshSuccess) onRefreshSuccess();

    } catch (err) {
      console.error('Refresh error:', err);
      message.error('Failed to refresh sandbox.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={visible}
      title="Refresh Sandbox"
      onCancel={handleCancel}
      footer={null}
      width={450}
      centered
    >
      <div style={{ textAlign: 'center', marginTop: 10 }}>
        <Text strong>
          Are you sure that you want to refresh the sandbox?
        </Text>
        <br />
        <Text type="danger">
          (This action is irreversible)
        </Text>
      </div>

      {loading && (
        <div style={{ textAlign: 'center', marginTop: 20 }}>
          <div className="rocket-loader">🚀</div>
          <Text>Preparing for refresh...</Text>

          <style>
            {`
              .rocket-loader {
                font-size: 36px;
                margin-bottom: 10px;
                animation: rocketPulse 1.6s ease-in-out infinite;
              }

              @keyframes rocketPulse {
                0% { transform: scale(1) translateY(0); opacity: 0.7; }
                50% { transform: scale(1.2) translateY(-5px); opacity: 1; }
                100% { transform: scale(1) translateY(0); opacity: 0.7; }
              }
            `}
          </style>
        </div>
      )}

      <div style={{ textAlign: 'right', marginTop: 30 }}>
        <Space>
          <Button onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            type="primary"
            danger
            loading={loading}
            onClick={handleConfirm}
          >
            Confirm
          </Button>
        </Space>
      </div>
    </Modal>
  );
};

export default RefreshOrgModal;